// extracted by mini-css-extract-plugin
export default {"confirmation":"ClientDelete_confirmation__IWvBJ","buttonGrid":"ClientDelete_buttonGrid__LBtck"};